// extracted by mini-css-extract-plugin
module.exports = {"qualitySelector":"de","label":"df","downloadSize":"dh","selectorWrapper":"di","selected":"dj"};